import { render, staticRenderFns } from "./StructuredClaimsEditor.vue?vue&type=template&id=73bf8bc7&scoped=true&"
import script from "./StructuredClaimsEditor.vue?vue&type=script&lang=js&"
export * from "./StructuredClaimsEditor.vue?vue&type=script&lang=js&"
import style0 from "./StructuredClaimsEditor.vue?vue&type=style&index=0&id=73bf8bc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf8bc7",
  null
  
)

export default component.exports